import type { SaveSmsSettingsRequest, SmsSettings } from '#lib/types/generated/index.js';

const GSM_CHARACTERS_REGEX =
	/^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!"#¤$%&\'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\[~\]|\u20AC]*$/;

export function sanitizeToGSM(text: string): string {
	return [...text].filter((char) => GSM_CHARACTERS_REGEX.test(char)).join('');
}

export function toSaveSmsSettingsRequest(settings: SmsSettings): SaveSmsSettingsRequest {
	return {
		sendBookingReminder: settings.sendBookingReminder,
		sendBookingReconfirmation: settings.sendBookingReconfirmation,
		sendBookingReview: settings.sendBookingReview,
		minutesBeforeBookingReminder: settings.minutesBeforeBookingReminder,
		reviewUrlType: settings.reviewUrlType,
		creditAutoRefillEnabled: settings.creditAutoRefillEnabled,
		creditAutoRefillAmount: settings.creditAutoRefillAmount,
		creditAutoRefillThreshold: settings.creditAutoRefillThreshold
	};
}
